<template>
    <div class="cp-home-doctor">
        <div :style="{
            'background-image': 'url(' + data.bg + ')',
            'width': '100%',
            'height': '100vh',
            'background-size': 'cover'
        }"></div>
        <div class="cp-home-doctor-content">
            <div :class="[
                'cp-home-doctor-content-left',
                'cp-home-doctor-ani-start',
                isRender ? 'cp-home-doctor-ani-1' : ''
                ]">
                <div>
                    <div class="cp-home-doctor-title">{{ data.title }}</div>
                    <div class="cp-home-doctor-text">{{ data.text }}</div>
                    <div class="cp-home-doctor-line"></div>
                </div>
                <div class="cp-home-doctor-tip">{{ data.tip }}</div>
            </div>
            <div class="cp-home-doctor-demo">
                <div
                  v-for="(row, i) in data.list"
                  :class="[
                      'cp-home-doctor-row',
                      'cp-home-doctor-ani-start',
                      isRender ? ('cp-home-doctor-ani-' + (i + 2)) : ''
                    ]"
                  :style="{
                    'margin-top': i === 0 ? '' : '1.24rem'
                  }">
                  <div
                    v-for="(col, i) in row"
                    class="cp-home-doctor-col">
                    <div v-if="col !== 'empty'">
                      <img
                        :src="col.avatar"
                        style="width: 1.2rem; height: 1.2rem;"/>
                      <div style="font-size: .18rem; margin-top: .18rem">{{ col.name }}</div>
                      <div style="font-size: .16rem; margin-top: .1rem; color: #666">{{ col.hosp }}</div>
                      <div style="font-size: .16rem; margin-top: .05rem; color: #666">{{ col.level }}</div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {equal} from '@/utils/core';
export default {
    name: 'cp-doctor',
    components: {
    },
    props: {
        isInView: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            isRender: false
        }
    },
    watch: {
        isInView(v) {
            if (v) {
                this.play();
            }
            else {
                this.isRender = false;
            }
        }
    },
    mounted() {
        this.play();
        this.$set(this.data, 'list', equal(this.data.list, 5, 'empty'));
    },
    methods: {
        play() {
            if (this.isInView) {
                setTimeout(() => {
                    this.isRender = true;
                }, 200);
            }
        }
    }
}
</script>

<style scoped>
.cp-home-doctor {
    position: relative;
}
.cp-home-doctor-content {
    position: absolute;
    top: 0;
    bottom: 0;
    padding: 0 1.2rem;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
}
.cp-home-doctor-content-left {
    display: flex;
    flex-direction:column;
    justify-content: space-between;
    position: absolute;
    height: 5.7rem;
}
.cp-home-doctor-title {
    font-size: .54rem;
    font-weight: bold;
}
.cp-home-doctor-text {
    font-size: .2rem;
    margin-top: .21rem;
}
.cp-home-doctor-tip {
    font-size: .16rem;
}
.cp-home-doctor-demo {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    font-size: .24rem;
    padding-left: 5rem;
}
.cp-home-doctor-line {
    width: .57rem;
    height: .04rem;
    background-color: #333;
    margin-top: .69rem;
}
.cp-home-doctor-row {
    display: flex;
    justify-content: space-between;
}
.cp-home-doctor-col {
    text-align: center;
    flex: 1;
    padding: 0 .25rem;
}
.cp-home-doctor-ani-start {
    transform: translateX(2.8rem);
    opacity: 0;
}
.cp-home-doctor-ani-1 {
    transition: all .6s ease-out;
    transform: translateX(0);
    opacity: 1
}
.cp-home-doctor-ani-2 {
    transition: all .5s ease-out .3s;
    transform: translateX(0);
    opacity: 1
}
.cp-home-doctor-ani-3 {
    transition: all .5s ease-out .5s;
    transform: translateX(0);
    opacity: 1
}
</style>



// WEBPACK FOOTER //
// src/components/home/Doctor.vue